var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.0500000,-0.0500000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 413 c-9 -8 -9 -346 -1 -367 9 -22 25 -20 64 9 32 23 41 25 156 25 129 0 137 3 139 47 1 28 -11 30 -25 3 -10 -18 -21 -20 -128 -20 -101 0 -120 -3 -142 -20 -14 -11 -28 -20 -32 -20 -5 0 -8 72 -8 160 l0 160 156 0 157 0 -6 -46 c-4 -38 -3 -44 8 -33 12 12 19 58 16 97 -1 9 -43 12 -174 12 -96 0 -177 -3 -180 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 359 c-3 -6 3 -20 14 -32 17 -17 24 -18 36 -8 14 12 13 15 -8 32 -28 22 -32 23 -42 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 344 c-19 -19 1 -24 99 -24 80 0 105 3 102 13 -5 13 -188 23 -201 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 280 c-48 -48 -48 -50 -30 -70 10 -11 21 -20 25 -20 4 0 26 23 50 51 42 50 42 51 24 70 -19 19 -20 18 -69 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 264 c-19 -20 2 -24 93 -22 58 2 100 7 100 13 0 11 -182 20 -193 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 197 c-3 -9 -7 -24 -10 -32 -3 -10 3 -15 20 -15 34 0 41 18 17 43 -19 19 -22 19 -27 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 178 c3 -9 32 -14 86 -16 68 -2 82 0 82 13 0 12 -15 15 -86 15 -64 0 -85 -3 -82 -12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequest);
export default __webpack_public_path__ + "static/media/new_request.e976581ac08c389a359a460c9c61c5a4.svg";
export { ForwardRef as ReactComponent };